import type { Deliverable } from './types'

/**
 * A detail panel has two recipe layouts:
 * - standalone: the item is one base Component, so render its recipe directly
 * - bundle: the item is composed of multiple Components, so render one recipe
 *   section per Component
 */
export function isSingleElementDeliverable(deliverable: Pick<Deliverable, 'kind' | 'components'>): boolean {
  return deliverable.kind === 'standalone' || deliverable.components.length <= 1
}

export function visibleComponentCount(deliverable: Pick<Deliverable, 'kind' | 'components'>): number | null {
  return isSingleElementDeliverable(deliverable) ? null : deliverable.components.length
}
